// ProductName
export enum ProductCategory {
  Activity = '营销活动H5',
  GetCustomer = '营销获客H5',
}

interface PagesInfo {
  title:string;
  category:ProductCategory;
  notCollectClick?:boolean;
}

interface PagesIn {
  '/marketing/poster':PagesInfo;
  '/marketing/transfer-page':PagesInfo;

}

// 定义页面title
const PagesInfo:PagesIn = {
  '/marketing/poster': {
    title: '编程猫海报',
    category: ProductCategory.Activity,
  },
  '/marketing/transfer-page': {
    title: '落地页中转页',
    category: ProductCategory.Activity,
  },
};

const DEFAULT_PAGE_INFO:PagesInfo = {
  title: '编程猫',
  category: ProductCategory.Activity,
};

// 根据当前页面路由匹配对应的神策信息
export const currPageInfo = PagesInfo[location.pathname as keyof PagesIn] || DEFAULT_PAGE_INFO;
